import BaseOutgoingPayload from "./base-outgoing-payload.ts";
import OutgoingPayloadEvent from "../../enums/outgoing-payload-event.ts";
import Coordinates from "../../models/coordinates.ts";

export default class V1GroupReady extends BaseOutgoingPayload {
  public readonly payload: V1GroupReadyPayload;

  constructor(coordinates: Coordinates, radius: number) {
    super(OutgoingPayloadEvent.V1_GROUP_READY);
    this.payload = new V1GroupReadyPayload(coordinates, radius);
  }
}

class V1GroupReadyPayload {
  public readonly coordinates: Coordinates;
  public readonly radius: number;

  constructor(coordinates: Coordinates, radius: number) {
    this.coordinates = coordinates;
    this.radius = radius;
  }
}
